import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function SocialCallback() {
  const nav = useNavigate();
  const { setSession } = useAuth();
  const done = useRef(false);
  useEffect(() => {
    if (done.current) { return; }
    done.current = true;
    const h = new URLSearchParams(window.location.hash.slice(1));
    const call = h.get("session_id") ? api.post("/auth/google/session", { sessionId: h.get("session_id") })
      : h.get("ticket") ? api.post("/auth/social/exchange", { ticket: h.get("ticket") }) : null;
    window.history.replaceState(null, "", window.location.pathname);
    if (!call) { nav("/login", { replace: true }); return; }
    call.then(({ data }) => {
      if (data.pending) { nav(`/registrati?social=${data.pending.id}`, { replace: true }); return; }
      setSession(data.token, data.user);
      toast.success(data.deletionCancelled ? "Bentornato! La cancellazione del tuo account è stata annullata." : "Accesso effettuato");
      nav("/dashboard", { replace: true });
    }).catch((e) => { toast.error(e?.response?.data?.detail || "Accesso non riuscito"); nav("/login", { replace: true }); });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
  return <div className="max-w-md mx-auto px-6 py-24 text-center text-slate-500" data-testid="social-callback">Accesso in corso…</div>;
}
